// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list","962":"home"}[chunkId] || chunkId) + "-" + {"137":"8f1952ff70d3f8ea3634","702":"bb8a1ab48e69194471dc","715":"cc702d43601a94c227d1","935":"31b987b22daee5c30772","962":"79b1afb3893a5003879e"}[chunkId] + ".css";
};